<template>
  <page-banner
    class="q-mt-sm"
    color="orange-8"
    dark
    dense
    icon="mdi-exclamation"
  >
    <q-item-label class="text-bold">
      You are running on a sandbox environment.
    </q-item-label>
    <q-item-label>SMS notifications will not be sent out.</q-item-label>
  </page-banner>
</template>
